<script>
  export let name = '';
  export let company = '';
  export let topic = '';
  export let imageSrc = '';
  export let imagePosition = 'center';
  export let href = '';

  let imageFailed = false;

  $: initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('');
</script>

{#if href}
  <a {href} class="expert-card" aria-label="{name} — {topic}">
    <div class="expert-image" aria-hidden="true">
      {#if imageSrc && !imageFailed}
        <img src={imageSrc} alt="" loading="lazy" style={`object-position: ${imagePosition};`} on:error={() => (imageFailed = true)}>
      {/if}
      {#if !imageSrc || imageFailed}
        <div class="expert-image-fallback">{initials}</div>
      {/if}
    </div>

    <div class="expert-body">
      <span class="expert-role">Эксперт</span>
      <div class="expert-main">
        <h3>{name}</h3>
        {#if Array.isArray(company)}
          {#each company as line}
            <p class="expert-company">{line}</p>
          {/each}
        {:else}
          <p class="expert-company">{company}</p>
        {/if}
      </div>
      <p class="expert-topic">{topic}</p>
    </div>
  </a>
{:else}
  <article class="expert-card">
    <div class="expert-image" aria-hidden={imageSrc ? 'true' : undefined}>
      {#if imageSrc && !imageFailed}
        <img src={imageSrc} alt="" loading="lazy" style={`object-position: ${imagePosition};`} on:error={() => (imageFailed = true)}>
      {/if}
      {#if !imageSrc || imageFailed}
        <div class="expert-image-fallback">{initials}</div>
      {/if}
    </div>

    <div class="expert-body">
      <span class="expert-role">Эксперт</span>
      <div class="expert-main">
        <h3>{name}</h3>
        {#if Array.isArray(company)}
          {#each company as line}
            <p class="expert-company">{line}</p>
          {/each}
        {:else}
          <p class="expert-company">{company}</p>
        {/if}
      </div>
      <p class="expert-topic">{topic}</p>
    </div>
  </article>
{/if}

<style>
  .expert-card {
    display: flex;
    min-width: 0;
    min-height: 544px;
    flex-direction: column;
    gap: 24px;
    overflow: hidden;
    border: 1px solid rgba(227, 208, 178, 0.1);
    border-radius: 24px;
    background: #161616;
    color: #ffffff;
    box-sizing: border-box;
    transition: border-color 200ms ease, transform 200ms ease, box-shadow 200ms ease;
    text-decoration: none;
  }

  a.expert-card {
    cursor: pointer;
  }

  .expert-card:hover,
  .expert-card:focus-visible {
    border-color: rgba(231, 185, 98, 0.55);
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
  }

  a.expert-card:focus-visible {
    outline: 2px solid #e7b962;
    outline-offset: 2px;
  }

  .expert-image {
    position: relative;
    flex: 0 0 318px;
    height: 318px;
    overflow: hidden;
    border-radius: 18px 18px 0 0;
    background: linear-gradient(135deg, #242424, #101010);
  }

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 400ms cubic-bezier(0.22, 0.61, 0.36, 1);
  }

  .expert-card:hover img,
  .expert-card:focus-visible img {
    transform: scale(1.04);
  }

  @media (prefers-reduced-motion: reduce) {
    .expert-card,
    .expert-card img {
      transition: none;
    }

    .expert-card:hover,
    .expert-card:focus-visible {
      transform: none;
    }

    .expert-card:hover img,
    .expert-card:focus-visible img {
      transform: none;
    }
  }

  .expert-image-fallback {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: rgba(231, 185, 98, 0.78);
    font-size: 64px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
  }

  .expert-body {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 16px;
    padding: 0 24px 24px;
    box-sizing: border-box;
  }

  .expert-role {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 12px 18px;
    border: 1px solid #e7b962;
    border-radius: 100px;
    color: #e7b962;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    text-transform: uppercase;
    box-sizing: border-box;
  }

  .expert-main {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  h3,
  p {
    margin: 0;
  }

  h3 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
  }

  .expert-company {
    min-height: 32px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.4;
    text-transform: uppercase;
  }

  .expert-topic {
    color: #e7b962;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  }

  @media (max-width: 1279px) {
    .expert-card {
      height: auto;
      min-width: 300px;
    }

    .expert-topic {
      line-height: 16px;
    }
  }

  @media (max-width: 767px) {
    .expert-card {
      min-width: 0;
    }

    .expert-body {
      padding: 0 16px 20px;
    }

    h3 {
      font-size: 20px;
      line-height: 22px;
    }

    .expert-company {
      font-size: 13px;
      line-height: 1.4;
    }
  }
</style>
